import { Helmet } from "react-helmet-async";
import { resolveOgImageUrl } from "../config/seoData";

const SEO = ({
  title,
  description,
  keywords,
  primaryKeyword,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  schema,
}) => {
  if (!title) {
    return null;
  }

  const schemaPayload = schema
    ? JSON.stringify(Array.isArray(schema) ? schema : [schema])
    : null;

  const socialTitle = (ogTitle || title).trim();
  const socialDescription = (ogDescription || description || "").trim();
  const socialImage = resolveOgImageUrl(ogImage);
  const socialUrl = (canonical || "").trim();

  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {primaryKeyword ? (
        <meta name="primary-keyword" content={primaryKeyword} />
      ) : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="India Boats" />
      <meta property="og:title" content={socialTitle} />
      {socialDescription ? (
        <meta property="og:description" content={socialDescription} />
      ) : null}
      {socialUrl ? <meta property="og:url" content={socialUrl} /> : null}
      <meta property="og:image" content={socialImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={socialTitle} />
      {socialDescription ? (
        <meta name="twitter:description" content={socialDescription} />
      ) : null}
      <meta name="twitter:image" content={socialImage} />

      {schemaPayload ? (
        <script type="application/ld+json">{schemaPayload}</script>
      ) : null}
    </Helmet>
  );
};

export default SEO;
